// src/components/AdminSettings/tabs/DisplayTab.tsx
import React from 'react';
import { useHistory } from 'react-router-dom';
import {
  IonList,
  IonItem,
  IonLabel,
  IonToggle,
  IonIcon,
  IonItemDivider,
  IonRange,
} from '@ionic/react';
import { sunny, moon, megaphoneOutline, chevronForward } from 'ionicons/icons';
import type { DisplayTabProps } from '../types';

export const DisplayTab: React.FC<DisplayTabProps> = ({
  settings,
  onUpdateSettings,
}) => {
  const history = useHistory();

  if (!settings) {
    return null;
  }

  return (
    <IonList>
      <IonItemDivider>
        <IonIcon icon={megaphoneOutline} slot="start" />
        Content Management
      </IonItemDivider>
      <IonItem button onClick={() => history.push('/settings/announcements')} detail>
        <IonIcon icon={megaphoneOutline} slot="start" color="primary" />
        <IonLabel>
          <h2>Announcements</h2>
          <p>Create and manage family announcements</p>
        </IonLabel>
        <IonIcon icon={chevronForward} slot="end" />
      </IonItem>
      <IonItemDivider>
        <IonIcon icon={sunny} slot="start" />
        Screensaver
      </IonItemDivider>
      <IonItem>
        <IonLabel>Enable Screensaver</IonLabel>
        <IonToggle
          checked={settings.screensaver_enabled}
          onIonChange={e => onUpdateSettings({ screensaver_enabled: e.detail.checked })}
        />
      </IonItem>
      <IonItem>
        <IonLabel>
          <h2>Idle Timeout</h2>
          <p>{settings.screensaver_timeout_minutes} minutes</p>
        </IonLabel>
        <IonRange
          min={1}
          max={30}
          value={settings.screensaver_timeout_minutes}
          onIonChange={e => onUpdateSettings({ screensaver_timeout_minutes: e.detail.value as number })}
        />
      </IonItem>
      <IonItem>
        <IonLabel>Show Clock</IonLabel>
        <IonToggle
          checked={settings.screensaver_show_clock}
          onIonChange={e => onUpdateSettings({ screensaver_show_clock: e.detail.checked })}
        />
      </IonItem>

      <IonItemDivider>
        <IonIcon icon={moon} slot="start" />
        Night Mode
      </IonItemDivider>
      <IonItem>
        <IonLabel>Enable Night Mode</IonLabel>
        <IonToggle
          checked={settings.night_mode_enabled}
          onIonChange={e => onUpdateSettings({ night_mode_enabled: e.detail.checked })}
        />
      </IonItem>
      <IonItem>
        <IonLabel>
          <h2>Night Brightness</h2>
          <p>{settings.night_mode_brightness}%</p>
        </IonLabel>
        <IonRange
          min={5}
          max={50}
          value={settings.night_mode_brightness}
          onIonChange={e => onUpdateSettings({ night_mode_brightness: e.detail.value as number })}
        />
      </IonItem>
    </IonList>
  );
};

export default DisplayTab;
